const API_NINJA_KEY = process.env.REACT_APP_API_NINJA_KEY;

export const fetchCitiesForState = async (stateCode) => {
  try {
    console.log('Fetching cities for state:', stateCode);
    console.log('Using API key:', API_NINJA_KEY);
    
    // Convert state code to full name for the API
    const stateMap = {
      'AL': 'Alabama', 'AK': 'Alaska', 'AZ': 'Arizona', 'AR': 'Arkansas',
      'CA': 'California', 'CO': 'Colorado', 'CT': 'Connecticut', 'DE': 'Delaware',
      'FL': 'Florida', 'GA': 'Georgia', 'HI': 'Hawaii', 'ID': 'Idaho',
      'IL': 'Illinois', 'IN': 'Indiana', 'IA': 'Iowa', 'KS': 'Kansas',
      'KY': 'Kentucky', 'LA': 'Louisiana', 'ME': 'Maine', 'MD': 'Maryland',
      'MA': 'Massachusetts', 'MI': 'Michigan', 'MN': 'Minnesota', 'MS': 'Mississippi',
      'MO': 'Missouri', 'MT': 'Montana', 'NE': 'Nebraska', 'NV': 'Nevada',
      'NH': 'New Hampshire', 'NJ': 'New Jersey', 'NM': 'New Mexico', 'NY': 'New York',
      'NC': 'North Carolina', 'ND': 'North Dakota', 'OH': 'Ohio', 'OK': 'Oklahoma',
      'OR': 'Oregon', 'PA': 'Pennsylvania', 'RI': 'Rhode Island', 'SC': 'South Carolina',
      'SD': 'South Dakota', 'TN': 'Tennessee', 'TX': 'Texas', 'UT': 'Utah',
      'VT': 'Vermont', 'VA': 'Virginia', 'WA': 'Washington', 'WV': 'West Virginia',
      'WI': 'Wisconsin', 'WY': 'Wyoming'
    };

    const stateName = stateMap[stateCode];
    if (!stateName) {
      throw new Error(`Invalid state code: ${stateCode}`);
    }

    const url = `https://api.api-ninjas.com/v1/cities?state=${encodeURIComponent(stateName)}&country=US&limit=30`;
    console.log('API URL:', url);
    
    const response = await fetch(url, {
      headers: {
        'X-Api-Key': API_NINJA_KEY
      }
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('API Error Response:', errorText);
      throw new Error(`Failed to fetch cities: ${response.status} ${errorText}`);
    }
    
    const cities = await response.json();
    console.log('Received cities:', cities);
    
    const formattedCities = cities.map(city => ({
      name: city.name,
      population: city.population
    })).sort((a, b) => b.population - a.population); // Sort by population
    
    console.log('Formatted cities:', formattedCities);
    return formattedCities;
  } catch (error) {
    console.error('Error in fetchCitiesForState:', error);
    // If API fails, use fallback cities
    return getFallbackCities(stateCode);
  }
};

// Expanded fallback cities list
export const getFallbackCities = (stateCode) => {
  console.log('Using fallback cities for state:', stateCode);
  const majorCities = {
    'AL': ['Birmingham', 'Montgomery', 'Mobile', 'Huntsville'],
    'AK': ['Anchorage', 'Fairbanks', 'Juneau', 'Sitka'],
    'AZ': ['Phoenix', 'Tucson', 'Mesa', 'Scottsdale'],
    'AR': ['Little Rock', 'Fort Smith', 'Fayetteville', 'Springdale'],
    'CA': ['Los Angeles', 'San Francisco', 'San Diego', 'Sacramento'],
    'CO': ['Denver', 'Colorado Springs', 'Aurora', 'Fort Collins'],
    'CT': ['Bridgeport', 'New Haven', 'Hartford', 'Stamford'],
    'DE': ['Wilmington', 'Dover', 'Newark', 'Middletown'],
    'FL': ['Miami', 'Orlando', 'Tampa', 'Jacksonville'],
    'GA': ['Atlanta', 'Savannah', 'Augusta', 'Athens'],
    'HI': ['Honolulu', 'Hilo', 'Kailua', 'Waipahu'],
    'ID': ['Boise', 'Nampa', 'Meridian', 'Idaho Falls'],
    'IL': ['Chicago', 'Aurora', 'Rockford', 'Joliet'],
    'IN': ['Indianapolis', 'Fort Wayne', 'Evansville', 'South Bend'],
    'IA': ['Des Moines', 'Cedar Rapids', 'Davenport', 'Sioux City'],
    'KS': ['Wichita', 'Overland Park', 'Kansas City', 'Topeka'],
    'KY': ['Louisville', 'Lexington', 'Bowling Green', 'Owensboro'],
    'LA': ['New Orleans', 'Baton Rouge', 'Shreveport', 'Lafayette'],
    'ME': ['Portland', 'Lewiston', 'Bangor', 'South Portland'],
    'MD': ['Baltimore', 'Columbia', 'Annapolis', 'Frederick'],
    'MA': ['Boston', 'Worcester', 'Springfield', 'Cambridge'],
    'MI': ['Detroit', 'Grand Rapids', 'Warren', 'Sterling Heights'],
    'MN': ['Minneapolis', 'Saint Paul', 'Rochester', 'Duluth'],
    'MS': ['Jackson', 'Gulfport', 'Southaven', 'Biloxi'],
    'MO': ['Kansas City', 'St. Louis', 'Springfield', 'Columbia'],
    'MT': ['Billings', 'Missoula', 'Great Falls', 'Bozeman'],
    'NE': ['Omaha', 'Lincoln', 'Bellevue', 'Grand Island'],
    'NV': ['Las Vegas', 'Reno', 'Henderson', 'North Las Vegas'],
    'NH': ['Manchester', 'Nashua', 'Concord', 'Dover'],
    'NJ': ['Newark', 'Jersey City', 'Paterson', 'Elizabeth'],
    'NM': ['Albuquerque', 'Las Cruces', 'Rio Rancho', 'Santa Fe'],
    'NY': ['New York City', 'Buffalo', 'Rochester', 'Albany'],
    'NC': ['Charlotte', 'Raleigh', 'Greensboro', 'Durham'],
    'ND': ['Fargo', 'Bismarck', 'Grand Forks', 'Minot'],
    'OH': ['Columbus', 'Cleveland', 'Cincinnati', 'Toledo'],
    'OK': ['Oklahoma City', 'Tulsa', 'Norman', 'Broken Arrow'],
    'OR': ['Portland', 'Salem', 'Eugene', 'Gresham'],
    'PA': ['Philadelphia', 'Pittsburgh', 'Allentown', 'Erie'],
    'RI': ['Providence', 'Warwick', 'Cranston', 'Pawtucket'],
    'SC': ['Columbia', 'Charleston', 'North Charleston', 'Mount Pleasant'],
    'SD': ['Sioux Falls', 'Rapid City', 'Aberdeen', 'Brookings'],
    'TN': ['Nashville', 'Memphis', 'Knoxville', 'Chattanooga'],
    'TX': ['Houston', 'Dallas', 'Austin', 'San Antonio'],
    'UT': ['Salt Lake City', 'West Valley City', 'Provo', 'West Jordan'],
    'VT': ['Burlington', 'South Burlington', 'Rutland', 'Essex Junction'],
    'VA': ['Virginia Beach', 'Norfolk', 'Chesapeake', 'Richmond'],
    'WA': ['Seattle', 'Spokane', 'Tacoma', 'Vancouver'],
    'WV': ['Charleston', 'Huntington', 'Parkersburg', 'Morgantown'],
    'WI': ['Milwaukee', 'Madison', 'Green Bay', 'Kenosha'],
    'WY': ['Cheyenne', 'Casper', 'Laramie', 'Gillette']
  };
  
  const cities = majorCities[stateCode] || [];
  console.log('Fallback cities:', cities);
  return cities.map(name => ({ name, population: 0 }));
};

// Format and validate location input
export const formatLocationInput = async (input, stateCode) => {
  try {
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';
    const response = await fetch(`${API_URL}/api/location/validate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        locationInput: input,
        stateCode: stateCode
      })
    });

    if (!response.ok) {
      throw new Error('Failed to validate location');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error validating location:', error);
    // Return the original input if validation fails
    return {
      formattedLocation: input,
      isValid: true,
      type: 'unknown'
    };
  }
}; 